import React from 'react';
import CandidateFeedback from 'components/assessments_pages/asessment_settings_components/CandidateFeedbackSettings';
import CandidateReminder from 'components/assessments_pages/asessment_settings_components/CandidateReminderSettings';
import CandidateRejection from 'components/assessments_pages/asessment_settings_components/CandidateRejectionSettings';

const CommunicationPage = props => (
    <div>
        <CandidateRejection {...props} />
        <CandidateReminder {...props} />
        <CandidateFeedback {...props} />
    </div>
);

export default CommunicationPage;
